(() => {
  const root = document.querySelector('[data-vsklo-gift-navigator]');
  if (!root) return;

  const currentKey = root.dataset.currentKey || '';
  const locale = root.dataset.locale || 'uk';
  const storageKey = 'vskloGiftInterest';
  const links = Array.from(root.querySelectorAll('[data-gift-key]'));
  const feature = root.querySelector('[data-gift-feature]');
  const status = root.querySelector('[data-gift-status]');

  const weights = {
    him: ['whiskey', 'sets', 'decanters', 'profession'],
    her: ['wine', 'sets', 'giftcards', 'decanters'],
    profession: ['sets', 'whiskey', 'decanters', 'giftcards'],
    auto: ['sets', 'whiskey', 'giftcards'],
    whiskey: ['sets', 'decanters', 'him', 'giftcards'],
    wine: ['sets', 'her', 'giftcards', 'decanters'],
    shots: ['sets', 'him', 'profession', 'giftcards'],
    decanters: ['whiskey', 'sets', 'him', 'giftcards'],
    sets: ['him', 'her', 'whiskey', 'wine'],
    giftcards: ['him', 'her', 'profession', 'sets']
  };

  const labels = {
    uk: {
      context: 'Ще один вдалий варіант',
      history: 'Схоже на те, що ви дивилися',
      popular: 'Може сподобатися'
    },
    en: {
      context: 'Another great option',
      history: 'Similar to what you viewed',
      popular: 'You may like this'
    },
    de: {
      context: 'Eine weitere passende Option',
      history: 'Ähnlich zu dem, was Sie angesehen haben',
      popular: 'Das könnte Ihnen gefallen'
    },
    pl: {
      context: 'Jeszcze jedna dobra propozycja',
      history: 'Podobne do tego, co oglądałeś',
      popular: 'To może Ci się spodobać'
    }
  };

  const localeKey = locale.startsWith('de') ? 'de' : locale.startsWith('pl') ? 'pl' : locale.startsWith('en') ? 'en' : 'uk';
  const ui = labels[localeKey];

  let previous = '';
  try {
    previous = sessionStorage.getItem(storageKey) || '';
  } catch (_) {}

  const priority = [];
  const addPriority = (key) => {
    if (key && !priority.includes(key)) priority.push(key);
  };

  (weights[currentKey] || []).forEach(addPriority);
  if (previous && previous !== currentKey) addPriority(previous);
  (weights[previous] || []).forEach(addPriority);

  const available = new Map(links.map((link) => [link.dataset.giftKey, link]));
  const firstSuggestedKey = priority.find((key) => available.has(key) && key !== currentKey);

  links.forEach((link) => {
    if (priority.includes(link.dataset.giftKey)) link.classList.add('is-suggested');
    if (link.dataset.giftKey === currentKey) link.setAttribute('aria-current', 'page');
    link.addEventListener('click', () => {
      try {
        sessionStorage.setItem(storageKey, link.dataset.giftKey || '');
      } catch (_) {}
    }, { passive: true });
  });

  if (feature && firstSuggestedKey) {
    const target = available.get(firstSuggestedKey);
    if (target) {
      feature.href = target.href;
      feature.dataset.giftKey = firstSuggestedKey;
      const title = feature.querySelector('[data-gift-feature-title]');
      const text = feature.querySelector('[data-gift-feature-text]');
      const kicker = feature.querySelector('[data-gift-feature-kicker]');
      if (title) title.textContent = target.dataset.title || target.textContent.trim();
      if (text && target.dataset.description) text.textContent = target.dataset.description;
      if (kicker) kicker.textContent = previous && previous !== currentKey ? ui.history : ui.context;
      if (status) status.textContent = previous && previous !== currentKey ? ui.history : ui.popular;
    }
  }

  if (currentKey) {
    try {
      sessionStorage.setItem(storageKey, currentKey);
    } catch (_) {}
  }

  root.dataset.enhanced = 'true';
})();
